import { apiClient } from './client';
import type {
  SubscriptionStatusResponse,
  PaymentHistoryResponse,
  CreatePaymentResponse,
} from '@/types/billing';

export const billingApi = {
  getSubscriptionStatus: async (): Promise<SubscriptionStatusResponse> =>
    (await apiClient.get<SubscriptionStatusResponse>('/v1/billing/status')).data,

  getPaymentHistory: async (): Promise<PaymentHistoryResponse> =>
    (await apiClient.get<PaymentHistoryResponse>('/v1/billing/payments')).data,

  createPayment: async (returnUrl: string): Promise<CreatePaymentResponse> =>
    (await apiClient.post<CreatePaymentResponse>('/v1/billing/pay', { return_url: returnUrl })).data,
};
